import customerApi from '../../components/apis/customerApi';

export function registerPhysicalCustomer(values) {
  return customerApi.post('/api/customers/physical', values).then((res) => res.data);
}

export function registerLegalCustomer(values) {
  return customerApi.post('/api/customers/legal', values).then((res) => res.data);
}
